import { useMemo } from 'react';
import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { marketingPricing } from 'self-service-api/core/utilities/links';
import { getProductLevelFromApiNameString, getProductLineFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { useSkuAdditionalUnits } from '../../components/merch-card/useSkuAdditionalUnits';
import { PRO_PLUS_PAGE_CONDITIONAL_WRAPPER } from '../../constants/ErrorBoundaryNames';
import { logHC0124Exposure, useIsHC0124Eligible } from '../../hooks/hc0124Hooks';
import { usePricingInfoFromApiName } from '../../hooks/upgradePageHooks';
import { useAppSelector } from '../../reducers';
import { hasProductVersionInBundledProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { purchaseMotionsSelector } from '../../selectors/PurchaseMotionSelectors';
import { withErrorBoundary } from '../ErrorBoundary';
import HC0124HubProPlusUpgradePage from './HC0124HubProUpgradePage';
import HubProPlusUpgradePage from './HubProPlusUpgradePage';
import { jsx as _jsx } from "react/jsx-runtime";
const ProPlusPageConditionalWrapper = ({
  handlePurchaseMotionButtonClick,
  hasPricingAndPurchasingSucceeded,
  purchaseMotions,
  upgradeConfig,
  upgradePointApiName,
  upgradeSource,
  isHC0124Variant,
  isHC0124Fetched
}) => {
  const productLine = getProductLineFromApiNameString(upgradePointApiName);
  const productLevel = getProductLevelFromApiNameString(upgradePointApiName);
  const {
    skuId
  } = useSkuAdditionalUnits({
    productLevel,
    productLine
  });
  const pricingInfo = usePricingInfoFromApiName(upgradePointApiName);
  const product = useAppSelector(state => {
    if (hasPricingAndPurchasingSucceeded) {
      return productForSkuIdSelector(state, {
        skuId: pricingInfo.skuId
      });
    }
    return null;
  });
  const apiName = product && product.apiName;
  const ownsProductViaBundle = useAppSelector(state => hasProductVersionInBundledProductInventorySelector(state, {
    skuId
  }));
  const merchCardPurchaseMotions = useAppSelector(state => purchaseMotionsSelector(state, {
    location: MERCH_CARD,
    skuId: pricingInfo.skuId
  }));
  const {
    isEligibleForHC0124
  } = useIsHC0124Eligible(isHC0124Fetched, apiName, merchCardPurchaseMotions, purchaseMotions, ownsProductViaBundle);
  const purchaseMotionsString = merchCardPurchaseMotions.toString();
  const updatedPurchaseMotions = useMemo(() => {
    if (isHC0124Fetched) {
      if (isEligibleForHC0124) {
        logHC0124Exposure();
        if (isHC0124Variant) {
          // We only want to change the first Purchase Motion
          return [merchCardPurchaseMotions[0], purchaseMotions[1]];
        }
      }
    }
    return purchaseMotions;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEligibleForHC0124, isHC0124Fetched, isHC0124Variant, purchaseMotionsString, purchaseMotions]);
  if (isEligibleForHC0124 && isHC0124Variant) {
    return /*#__PURE__*/_jsx(HC0124HubProPlusUpgradePage, {
      upgradePointApiName: upgradePointApiName,
      upgradeConfig: upgradeConfig,
      purchaseMotions: updatedPurchaseMotions,
      handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
      upgradeSource: upgradeSource
    });
  }
  return /*#__PURE__*/_jsx(HubProPlusUpgradePage, {
    upgradePointApiName: upgradePointApiName,
    upgradeConfig: upgradeConfig,
    purchaseMotions: purchaseMotions,
    handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
    upgradeSource: upgradeSource
  });
};
export default withErrorBoundary(ProPlusPageConditionalWrapper, {
  boundaryName: PRO_PLUS_PAGE_CONDITIONAL_WRAPPER,
  redirectCallback: marketingPricing
});